import React , { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Hero from '../components/Hero';
// import DiwaliOverlay from '../components/DiwaliOverlay';
import LatestCollection from '../components/Oversized';
import BestSeller from '../components/BestSeller';
import OurPolicy from '../components/OurPolicy';
import NewsletterBox from '../components/NewsletterBox';
import OfferCarasol from './OfferCarasol';
import ExCollection from '../components/ExCollection';
import NavbarBanner from '../components/NavbarBanner'; // Import NavbarBanner
import OversizedTShirts from '../components/Oversized';
import Sweatshirts from '../components/Sweatshirts';
import Hoodies from '../components/Hoodies';
import axios from 'axios';
const Home = () => {
   useEffect(() => {
    const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
    axios.post(`${backendUrl}/api/analytics/visit`, { page: "Home" })
      .then(res => console.log("About page visit recorded:", res.data))
      .catch(err => console.error("Analytics error:", err));
  }, []);

  return (
    
   <div>
    {/* <DiwaliOverlay /> */}
   
      <Helmet>
        <title>Mammoth Streetwear | Trendy Streetwear Clothing & Accessories</title>
        <meta
          name="description"
          content="Shop Mammoth Streetwear's latest collection of oversized t-shirts, hoodies, sweatshirts, and more. Trendy fashion for men and women at affordable prices."
        />
        <meta name="keywords" content="Mammoth Streetwear, streetwear, oversized t-shirts, hoodies, sweatshirts, urban fashion, trendy clothing" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Mammoth Streetwear | Trendy Streetwear Clothing & Accessories" />
        <meta
          property="og:description"
          content="Explore the latest streetwear fashion trends. Shop Mammoth's exclusive collection of oversized t-shirts, hoodies, sweatshirts, and more."
        />
        <meta property="og:image" content="https://res.cloudinary.com/djqeoutoy/image/upload/v1736317496/thvchjshphqfuzfr998m.png" />
        <meta property="og:url" content="https://mammothstreetwears.com" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mammoth Streetwear | Trendy Streetwear Clothing & Accessories" />
        <meta
          name="twitter:description"
          content="Shop Mammoth Streetwear's latest collection of oversized t-shirts, hoodies, sweatshirts, and more. Urban fashion at its best."
        />
        <meta name="twitter:image" content="https://res.cloudinary.com/djqeoutoy/image/upload/v1736317496/thvchjshphqfuzfr998m.png" />
        <link rel="canonical" href="https://mammothstreetwears.com/" />
      </Helmet>
     <div className="px-0 lg:px-20 mt-0">
  <Hero />
</div>
    
      
      <h1 className="text-l lg:text-xl font-bold mb-6 text-center">
        <span className="rounded-lg px-4 py-2 inline-block mt-8">
           "Step Into Mammoth Streetwear  Where Style Meets <br/> Trendsetting Fashion"
        </span>
      </h1>

      <ExCollection />
     
     
      <h1 className="text-xl lg:text-3xl font-bold mb-6 text-center">
        <span className="rounded-lg px-4 py-2 inline-block mt-8">
          Trend To Tradition
        </span>
      </h1>

      <OfferCarasol />
      
      
      <OversizedTShirts />
      <div className='bg-[#e0e0e0]'>
      <Hoodies />
      <Sweatshirts />
      <OurPolicy />
      </div>
      <NavbarBanner /> {/* Add NavbarBanner here */}
    </div>
  );
};

export default Home;
